import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CoreDirectivesModule } from '@core/directives/core.directives.module';
import { TranslationModule } from '@core/translation/translation.module';

/*
* TODO: ... clean up the modules ... use core module ...
* DO import modules that should be instantiated once in your app.
* DO place services in the module, but do not provide them.
* DO NOT declare components, pipes, directives.
* DO NOT import the CoreModule into any modules other than the AppModule.
* */
@NgModule({ declarations: [],
    exports: [TranslationModule], imports: [CommonModule,
        CoreDirectivesModule,
        TranslationModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class CoreModule {

}
